export const SET_ITEM = 'SET_ITEM';

export const setItem = value => ({
  type: SET_ITEM,
  payload: value
});



// WEBPACK FOOTER //
// ./src/redux/actions/itemActions.js